import React from "react";
import cn from "classnames";

export interface ComboxListGroupProps {
  children: React.ReactNode;
  label?: React.ReactNode;
  className?: string;
}

export const ComboxListGroup = ({ children, label, className }: ComboxListGroupProps) => {
  return (
    <div className={cn("", className)} role="group">
      {label && (
        <div className="text-charcoal-400 px-2 py-1.5 text-xs font-medium uppercase tracking-wider">
          {label}
        </div>
      )}
      <div className="flex flex-col gap-px">{children}</div>
    </div>
  );
};

export default ComboxListGroup;
